module.exports = __webpack_public_path__ + "static/icon-d4d4f78aab7ebdcc290bd67ae62f6ab6.png";